import { useEffect, useState } from 'react';

export const useKey = index => {
    const [key, setKey] = useState(index);

    useEffect(() => {
        setKey(index);
    }, [key, index]);

    return { key, setKey };
};
